(() => {
  const initialise = picker => {
    if (picker.dataset.buddiesReady === 'true') return;
    const section = picker.closest('[id^="MainProduct-"]') || picker.closest('section');
    if (!section) return;
    const cards = Array.from(picker.querySelectorAll('.mini-size-card'));
    const select = Array.from(section.querySelectorAll('variant-selects select')).find(input =>
      cards.length && cards.every(card => Array.from(input.options).some(option => option.value === card.dataset.size)));
    if (!select) return;
    picker.dataset.buddiesReady = 'true';
    const field = select.closest('.field');
    if (field) field.style.display = 'none';
    const sync = () => cards.forEach(card => {
      const active = card.dataset.size === select.value;
      card.classList.toggle('active', active);
      card.setAttribute('aria-pressed', String(active));
    });
    cards.forEach(card => {
      card.setAttribute('role', 'button');
      card.tabIndex = 0;
      const choose = () => {
        select.value = card.dataset.size;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      };
      card.addEventListener('click', choose);
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose();
        }
      });
    });
    select.addEventListener('change', sync);
    sync();
  };
  const scan = root => {
    if (root.matches?.('[data-size-picker]')) initialise(root);
    root.querySelectorAll?.('[data-size-picker]').forEach(initialise);
    const section = root.closest?.('[id^="MainProduct-"]');
    section?.querySelectorAll('[data-size-picker]').forEach(initialise);
  };
  customElements.whenDefined('variant-selects').then(() => {
    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && (node.matches('[data-size-picker], select, variant-selects') ||
            node.querySelector('[data-size-picker], variant-selects'))) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
